// @flow

import { compose, lensPath, lensProp } from "ramda";

export const campoArquivosMedidasLens = (campo: string) =>
  lensPath(["arquivosMedidas", campo]);

export const edicaoMedidaLens = (grupamento: string): any =>
  lensPath(["edicaoMedida", grupamento]);
export const campoEdicaoMedidaLens = (
  grupamento: ?string,
  campo: string
): any =>
  grupamento
    ? lensPath(["edicaoMedida", grupamento, campo])
    : lensPath(["edicaoMedida", campo]);

export const medidasSelecionadasLens: any = lensProp("medidasSelecionadas");

export const medidasParaPersonalizarLens: any = lensProp(
  "medidasParaPersonalizar"
);

export const seletoresAbertosLens = (id: string) =>
  lensPath(["seletoresAbertos", id]);

export const dataBaseDefaultLens = lensPath(["dominio", "dataBaseDefault"]);

export const dataBaseLens = lensProp("dataBase");

const qtlinkLens = lensProp("funcaoQtLink");
export const funcaoQtlinkLens = compose(qtlinkLens, lensProp("conteudo"));
export const carregandoFuncaoQtlinkLens = compose(
  qtlinkLens,
  lensProp("carregando")
);

export const isAxisLens = lensProp("isAxis");

export const gridState = lensProp("gridState");
export const gridAggregationState = compose(gridState, lensProp("aggregation"));
export const gridSortState = compose(gridState, lensProp("sort"));
export const gridFilterState = compose(gridState, lensProp("filter"));
export const gridGroupState = compose(gridState, lensProp("group"));
export const gridOrderState = compose(gridState, lensProp("order"));
export const gridFixedRightState = compose(gridState, lensProp("fixedRight"));
export const gridFixedLeftState = compose(gridState, lensProp("fixedLeft"));

export const modoVisualizacaoSeriesLens = lensPath([
  "configuracaoSeries",
  "modoVisualizacao",
]);
